import React, { useEffect } from "react";

// Components
import { PageWrapper, InnerWrapper } from "./FulfillmentProductCreatePage.styles";
import Header from "./Header";
import ProductInfo from "./ProductInfo";
import ProductDetails from "./ProductDetails";
import PackingDetails from "./PackingDetails";
import CustomsInfo from "./CustomsInfo";
import BaseProducts from "./BaseProducts";
// import PackageRequirements from "./PackageRequirements";

// Helpers
import resize from "../../../helperFunctions/FulfillmentProductCreatePage/resize";
import useProductCreateFlow from "../../../hooks/reduxContainer/fulfillment/productCreateFlow";
import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlagQuery";

const FulfillmentProductCreatePage: React.FC = () => {
  const { isEditing, product, dispatchSetIsEditing, dispatchResetProduct } = useProductCreateFlow();
  const {
    product_type,
    name,
    image,
    image_url,
    active,
    description,
    scid,
    sku,
    upc,
    length,
    width,
    height,
    weight,
    weight_unit,
    tracks_lot_numbers,
    dangerous,
    fragile,
    contains_battery,
    liquid,
    tracks_expiry_date,
    days_before_expiry_to_block_fulfillment,
    packaging_levels,
    hs_tariff_code,
    customs_description,
    cost,
    wholesale_price,
    retail_price,
    insurance_required,
    insurance_value,
    under_conversion,
  } = product;

  const showPackingDetails = useFeatureFlagQuery("show-product-packing-details", { org_id: product.organization_id });

  useEffect(() => {
    resize();
    dispatchSetIsEditing(true);
    dispatchResetProduct();
    // eslint-disable-next-line
  }, []);

  const renderBody = () => {
    if (packaging_levels && product_type === "base") {
      return (
        <>
          <ProductDetails
            isEditing={isEditing}
            length={length}
            width={width}
            height={height}
            weight={weight}
            weight_unit={weight_unit}
            tracks_lot_numbers={tracks_lot_numbers}
            dangerous={dangerous}
            fragile={fragile}
            contains_battery={contains_battery}
            liquid={liquid}
            tracksExpiryDate={tracks_expiry_date}
            daysBeforeExpiryToBlockFulfillment={days_before_expiry_to_block_fulfillment}
          />
          {showPackingDetails.data?.state && <PackingDetails packaging_levels={packaging_levels} />}
          <CustomsInfo
            hs_tariff_code={hs_tariff_code}
            customs_description={customs_description}
            cost={cost}
            wholesale_price={wholesale_price}
            retail_price={retail_price}
          />
          {/* <PackageRequirements /> */}
        </>
      );
    }
    if (product_type === "kit") {
      return <BaseProducts />;
    }
  };

  return (
    <PageWrapper>
      <Header />
      <InnerWrapper>
        <ProductInfo
          isCreate
          isEditing={isEditing}
          name={name}
          image={image}
          image_url={image_url}
          product_type={product_type}
          active={active}
          description={description}
          scid={scid}
          sku={sku}
          upc={upc}
          insuranceRequired={insurance_required}
          insuranceValue={insurance_value}
          cost={cost}
          under_conversion={under_conversion}
        />
        {renderBody()}
      </InnerWrapper>
    </PageWrapper>
  );
};

export default FulfillmentProductCreatePage;
